import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ImportImagesPage } from './import-images.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'image',
        component: ImportImagesPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [ImportImagesPage]
})
export class ImportImagesPageModule {}
